// MHNotify — 二次封装 Element UI Notification，统一默认参数 [Claude Code]
import { Notification } from 'element-ui'

/**
 * 全局通知方法，用法与 Element UI Notification 一致 [Claude Code]
 * 默认注入: offset: 80, customClass 根据 type 自动拼接 [Claude Code]
 * @param {Object} options - Element UI Notification 参数
 * @returns {Notification} Notification 实例，可调用 .close()
 */
function MHNotify (options) {
  if (typeof options === 'string') {
    options = { message: options }
  }
  const type = options.type || 'info'
  // 根据 type 自动生成默认 customClass [Claude Code]
  const defaultClass = `${type}-detail-notification`
  const customClass = options.customClass
    ? `${options.customClass} ${defaultClass}`
    : defaultClass

  return Notification({
    offset: 40,
    ...options,
    customClass
  })
}

// 快捷方法: MHNotify.success({...}) / MHNotify.error({...}) 等 [Claude Code]
['success', 'warning', 'info', 'error'].forEach(type => {
  MHNotify[type] = (options) => {
    if (typeof options === 'string') {
      options = { message: options }
    }
    return MHNotify({ ...options, type })
  }
})

// 透传 Element Notification 的静态方法 [Claude Code]
MHNotify.close = (id) => Notification.close(id)
MHNotify.closeAll = () => Notification.closeAll()

export default MHNotify
